import { css } from '@microsoft/fast-element';
import { gridButtonStyling } from '../../../styles';

export const WatchlistProjectCardStyles = css`
  ${gridButtonStyling}

  .favorite-icon {
    background: none;
    height: 30px;
    width: 26px;
    float: right;
  }

  .watchlist-project-card {
    padding: 11px 9px;
    border-bottom: 1px solid var(--border-1);
    background-color: rgb(135 155 166 / 0%);
    box-sizing: border-box;
    display: flex;
  }

  .watchlist-project-card-opened {
    background-color: rgb(45 47 51 / 100%);
  }

  .content {
    border-radius: 6px;
    box-sizing: border-box;
  }

  .project-header-container {
    display: flex;
    gap: 3px;
    height: 20px;
    align-items: center
  }

  .project-name {
    color: var(--primary-color);
    margin: 0;
    font-size: 13px;
    float: left;
  }

  .project-name:hover {
    cursor: pointer;
    text-decoration: underline;
  }

  .project-legal-name {
    color: var(--gray-lighter);
    margin: 0;
    font-size: 10px;
    font-weight: 500;
    min-height: 21px;
    align-content: center;
  }

  .project-bg {
    width: 100%;
    height: 100%;
    padding: 2px;
    border: 1px solid var(--primary-color);
    background-color: #17181b;
    box-sizing: border-box;
  }

  .remove-from-your-wat {
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    color: var(--white-smoke);
  }

  .delete-title {
    font-weight: 700;
    font-style: normal;
    font-size: 14px;
    color: var(--primary-color);
  }

  .cancel {
    height: 22px;
    border-radius: 4px;
    border: 1px solid var(--gray-lighter);
    background-color: rgb(135 155 166 / 50%);
    box-sizing: border-box;
    font-family: Roboto-Regular, Roboto, sans-serif;
    color: var(--white);
    text-align: center;
    line-height: normal;
  }

  .remove {
    height: 22px;
    border-radius: 4px;
    border: 1px solid var(--error);
    background-color: rgb(249 100 77 / 50%);
    box-sizing: border-box;
    font-family: Roboto-Regular, Roboto, sans-serif;
    color: var(--white);
    text-align: center;
    line-height: normal;
  }

  .project-bg .btn-holder {
    justify-content: flex-end;
    display: flex;
    gap: 12px;
    margin-right: 12px;
    margin-bottom: 12px;
  }

  .button-container {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .chevron-control-button {
    width: 31px;
    height: 22px;
    border-radius: 2px;
    background-color: rgb(135 155 166 / 10%);
  }

  .chevron-control-button::part(control) {
    padding: 2px;
  }

  .chevron-control-button::part(end) {
    transition: all 0.5s ease;
  }

  .chevron-control-button svg {
    width: auto;
    height: auto;
  }

  .rotate-icon::part(end) {
    transform: rotate(90deg);
    transition: all 0.5s ease;
  }

  .vppa-grid {
    height: 100px;
  }

  .grid-styles {
    width: 100%;
    height: 100%;
  }

  .icon {
    padding-right: 10px;
    display: flex;
    align-items: center;
  }

  zero-grid-pro::part(actionWrapper) {
    justify-content: unset;
  }

  zero-grid-pro::part(gridIconButton) {
    background-color: transparent;
  }

  zero-grid-pro::part(leftButtons) {
    display: none;
  }

  zero-grid-pro::part(hyperlinkStatic) {
    text-decoration: unset;
  }

  zero-grid-pro::part(hyperlinkStatic):hover {
    text-decoration: underline;
  }
`;
